import { AuthorizedApiService } from "../../../services/apiServices";
import { notification } from "antd";

import { GET_BRANDS, GET_SINGLE_BRAND, RESET_BRAND } from "./types";

export const getBrands =
  (supplierId = null) =>
  async (dispatch) => {
    try {
      const url = supplierId ? `/brand/${supplierId}` : `/brand`;

      AuthorizedApiService.get(url)
        .then((res) => {
          const { status, data } = res;
          if (status !== 200) {
            notification.error({
              message: "Something went wrong",
            });
            return;
          }
          dispatch({
            type: GET_BRANDS,
            payload: data,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      notification.error({
        message: "Something went wrong",
      });
      console.log(error);
    }
  };

export const getSingleBrand = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_BRAND,
    });
    AuthorizedApiService.get(`/brand/${id}`)
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        dispatch({
          type: GET_SINGLE_BRAND,
          payload: data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (error) {
    notification.error({
      message: "Something went wrong",
    });
    console.log(error);
  }
};

export const deleteBrand = (ids) => async (dispatch) => {
  try {
    AuthorizedApiService.delete(`brand`, {
      data: { ids },
    })
      .then((res) => {
        console.log("am i here", ids);
        const { status } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        notification.success({
          message: ids.length === 1 ? "Brand deleted" : "Brands deleted",
        });
        dispatch(getBrands());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
  }
};

export const updateBrand = (id, updatedBrand) => async (dispatch) => {
  try {
    AuthorizedApiService.put(`brand/${id}`, updatedBrand)
      .then((res) => {
        const { status } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        notification.success({
          message: "Brand updated",
        });
        dispatch(getBrands());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
  }
};

export const addBrand = (brand) => async (dispatch) => {
  try {
    AuthorizedApiService.post(`brand`, brand)
      .then((res) => {
        const { status } = res;
        if (status !== 201) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        notification.success({
          message: "Brand added",
        });
        dispatch(getBrands());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
  }
};
